import { IMAGE_GALLERY_BREAKPOINTS } from '../../../utils/constants'
import { getOptimizedImageExtension } from '../../../utils/image-extensions'
import { HeadTag, HeadTagInput, MediaWidthPair } from '../../../utils/prop-types'
import { InitialProductData } from './types'

const createHeadTags = <T extends Record<string, string>>(
  tags: HeadTagInput<T>[]
): HeadTag[] =>
  tags.map(({ tagName, properties }) => ({
    tagName,
    properties
  }))

const generateLinkTags = (
  initialProductData: InitialProductData,
  mediaWidthPairs: MediaWidthPair[]
): HeadTagInput<Record<string, string>>[] => {
  const assetFullUrl = initialProductData?.assets?.[0]?.assetFullUrl

  return assetFullUrl ? mediaWidthPairs.map(({ mediaQuery, width }) => ({
    tagName: 'link',
    properties: {
      rel: 'preload',
      as: 'image',
      href: `${getOptimizedImageExtension(assetFullUrl)}?width=${width}`,
      fetchpriority: 'high',
      media: mediaQuery
    }
  })) : []
}

const headTagsConfig = (initialProductData: InitialProductData): HeadTag[] => {
  const linkTags = generateLinkTags(initialProductData, IMAGE_GALLERY_BREAKPOINTS)

  return createHeadTags(linkTags)
}

export default headTagsConfig
